import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=66844a85&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66844a85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66844a85')) {
      api.createRecord('66844a85', component.options)
    } else {
      api.reload('66844a85', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=66844a85&scoped=true&", function () {
      api.rerender('66844a85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Operator/Components/Index.vue"
export default component.exports